import styled from '@emotion/styled/macro';
import { Flex, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'store';
import BlockContent from '@sanity/block-content-to-react';
import { loadWeChoooseTerms } from 'modules/terms/termsSlice';
import { Loader, PolicyPage } from 'components';
import { isCorporateThemeSelector } from 'modules/app/appSlice';

const LoaderWrapper = styled(Flex)`
  padding-top: 60px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const StyledText = styled(Text)`
  line-height: 160%;
  margin-bottom: 6px;
`;

const WeChoooseTerms: FC = () => {
  const { t } = useTranslation('settings');
  const { loading, wechoooseTerms, wechoooseUpdateTime } = useSelector((state: RootState) => state.terms);
  const dispatch = useDispatch();
  const isCorporateTheme = useSelector(isCorporateThemeSelector);

  useEffect(() => {
    if (!wechoooseTerms || !wechoooseTerms.length) {
      dispatch(loadWeChoooseTerms());
    }
  }, [wechoooseTerms]);

  if (loading) {
    return (
      <LoaderWrapper data-testid="loader">
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <>
      {wechoooseUpdateTime && (
        <StyledText fontSize={isCorporateTheme ? 'xs' : 'mdMax'} fontWeight={isCorporateTheme ? 400 : 500} color="secondary.500">
          {t('terms.updated')}: {format(new Date(wechoooseUpdateTime), 'PP')}
        </StyledText>
      )}
      <PolicyPage showButton>
        <BlockContent blocks={wechoooseTerms} />
      </PolicyPage>
    </>
  );
};

export default WeChoooseTerms;
